import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CoverageSpecificationInterface, PurchasedProductInterface } from 'outshared-lib';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { WucButtonModule, WucTableModule } from '@inshared/website-ui-components';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'ins-premium-summary',
    templateUrl: './premium-summary.component.html',
    imports: [
        CommonModule,
        ListModule,
        WucTableModule,
        WucButtonModule
    ]
})
export class PremiumSummaryComponent implements OnChanges {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public coverages!: CoverageSpecificationInterface[];
    @Input() public expand: boolean = false;
    public totals: Record<string, number>;

    public ngOnChanges(changes: SimpleChanges): void {
        this.totals = this.calculatedPremium();
    }

    private calculatedPremium(): Record<string, number> {
        return this.coverages.reduce(
            (total, purchasedCoverage): Record<string, number> => {
                return {
                    subTotal: total.subTotal + purchasedCoverage.premium.premiumIncludingPremiumTax,
                    total: total.total + purchasedCoverage.premiumIncludingDiscount.premiumIncludingPremiumTax,
                    collectivityDiscount: total.collectivityDiscount +
                        (purchasedCoverage.collectivityDiscount ? purchasedCoverage.collectivityDiscount.premiumIncludingPremiumTax : 0),
                    offerDiscount: total.offerDiscount +
                        (purchasedCoverage.discount ? purchasedCoverage.discount.premiumIncludingPremiumTax : 0),
                }
            },
            {
                subTotal: 0,
                total: 0,
                collectivityDiscount: 0,
                offerDiscount: 0,
            });


    }
}
